<template>
  <div>
      <div class="bg-[url('../../assets/home.jpg')] bg-fixed w-full h-screen bg-cover bg-center text-gray-200">
        <h1 class="pt-64 md:text-8xl text-gray-50 font-bold pb-5 text-6xl" style="font-family: Caveat;">{{ $t('home.p1') }}<br></h1>
        <typewriter
  :speed="200"
  :full-erase="true"
  :interval="300"
  :words='["Developer", "Creator", "Designer"]'
  class="pt-64 md:text-8xl text-gray-50 font-bold text-5xl"
  style="font-family: Caveat;">
</typewriter>
<br>
        <router-link to="/aboutus"><button type="submit" class="mt-4 text-2xl bg-slate-100 px-6 py-4 text-gray-900 rounded-full hover:text-gray-50 hover:bg-black hover:ease-in duration-200 font-semibold" style="font-family: Caveat;">{{ $t('about.button')}}</button></router-link> 
      </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  
}
</script>